import {Space} from "antd";
import {LiveEventSubGenInfoFormFieldsProps} from "./types";
import {LiveEventSubGenInfoNameFormField} from "./name-form-field";
import {LiveEventSubGenInfoDescriptionFormField} from "./description-form-field";

export function LiveEventSubGenInfoFormFields({
  nameFieldId,
  nameFieldLabel,
  nameFieldPlaceholder,
  descriptionFieldId,
  descriptionFieldLabel,
  descriptionFieldPlaceholder,
  coverImageFieldId,
  coverImageFieldLabel,
  coverImageFieldPlaceholder,
}: LiveEventSubGenInfoFormFieldsProps) {
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <LiveEventSubGenInfoNameFormField
          id={nameFieldId}
          label={nameFieldLabel}
          placeholder={nameFieldPlaceholder}
        />
        <LiveEventSubGenInfoDescriptionFormField
          id={descriptionFieldId}
          label={descriptionFieldLabel}
          placeholder={descriptionFieldPlaceholder}
        />
      </Space>
    </div>
  );
}
